"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabNav = void 0;
function TabNav() {
    return null;
}
exports.TabNav = TabNav;
//# sourceMappingURL=TabNav.js.map